import { QueryClient } from '@tanstack/react-query';
import { getRocketErrorRedirectPath, mapAxiosErrorToRocketError } from 'util/apiErrors';

import { createAppRouter as createSharedAppRouter } from '@shared/router/createAppRouter';

import { routeTree } from './routeTree.gen';

export function createAppRouter(queryClient: QueryClient) {
  return createSharedAppRouter({
    routeTree,
    queryClient,
    mapAxiosErrorToRocketError,
    getRedirectPath: getRocketErrorRedirectPath,
    defaultErrorRedirect: '/n/sites',
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module '@tanstack/history' {
  interface HistoryState {
    parentState?: string;
    errorSnackbar?: string;
  }
}

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }

  interface StaticDataRouteOption {
    routeTitle?: string;
  }
}
